'use strict';
import { EventEmitter } from 'events';

const SECONDS_PER_CHUNK = 1;

export default class Recorder extends EventEmitter {
    constructor(options = {}) {
        super();

        this.debug = options.debug || function(){};
        this.stream = options.stream || null;
        this.hasVideo = false;
        this.recorder = null;

        if (!(this.stream instanceof MediaStream)) throw new Error('No valid media stream.');
        this.hasVideo = this.stream.getVideoTracks().length > 0;

        if (!this._hasMediaRecorder()) {
            throw new Error(`Your browser doesn't support recording, please update to the latest version. (we recommend Chrome on desktop)`);
        }

        if (this._hasMediaRecorder()) {
            this.recorder = this._createNative(this.stream);
        }

        this._initListeners();
    }

    start() {
        this.debug('start()');
        if (!this.recorder) {
            this.debug('ERROR: No MediaRecorder initialised.');
            return false;
        }

        if (this.recorder.state === 'recording') {
            this.debug('WARNING: Already recording.');
            return false;
        }

        this.recorder.start(SECONDS_PER_CHUNK * 1000);
        return true;
    }

    stop() {
        this.debug('stop()');
        if (!this.recorder) {
            this.debug('ERROR: No MediaRecorder initialised.');
            return false;
        }

        this.recorder.stop();
    }

    cutAudio(isCut) {
        this.debug('cutAudio()', isCut);
        if (!this.stream) return;
        let track = this.stream.getAudioTracks()[0];
        if (!track) return;
        track.enabled = !isCut;
    }

    _initListeners() {
        this.debug('_initListeners()');
        if (!this.recorder) {
            this.debug('ERROR: No MediaRecorder initialised.');
            return;
        }

        this.recorder.onstart = () => {
            this.debug('onStart');
            this.emit('start');
        }

        this.recorder.onstop = () => {
            this.debug('onStop');
            this.emit('stop');
        }

        this.recorder.onerror = (event) => {
            this.debug('onError', event);
            this.emit('error', event);
        }

        this.recorder.ondataavailable = (event) => {
            if (typeof event.data === 'undefined') return;
            if (event.data.size === 0) return;
            this.emit('chunk', event.data);
        }
    }

    _createNative(stream) {
        this.debug('_createNative()');


        let options = {};
        if (!this.hasVideo) {
            options.audioBitsPerSecond = 128000;
            options.mimeType = this._supportedAudioMimeType();
        } else {
            options.audioBitsPerSecond = 128000;
            options.videoBitsPerSecond = 2500000;
            options.mimeType = this._supportedVideoMimeType();
        }

        return new MediaRecorder(stream, options);
    }

    _hasMediaRecorder() {
        if (window.MediaRecorder && MediaRecorder.isTypeSupported) return true;
        return false;
    }

    _supportedAudioMimeType() {
        let types = ['audio/mp4', 'audio/webm'];
        let result = undefined;
        types.map((type) => {
            if (MediaRecorder.isTypeSupported(type)) {
                result = type;
            }
        });

        return result;
    }

    _supportedVideoMimeType() {
        let types = ['video/mp4', 'video/webm'];
        let result = undefined;
        types.map((type) => {
            if (MediaRecorder.isTypeSupported(type)) {
                result = type;
            }
        });

        return result;
    }
}